import BlogList from "../components/BlogList";
import DarkModeToggle from "../components/DarkModeToggle";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="container mx-auto pt-20">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6">
        <Link
          to="/"
          className="text-2xl font-bold text-gray-900 dark:text-white"
        >
          Home
        </Link>
        <DarkModeToggle />
      </div>

      {/* Blog List */}
      <BlogList />
    </div>
  );
};

export default Home;
